// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"1bd11469","14":"670e1fcc","162":"d2a05556","591":"b9948bd4","674":"443b9ba0","890":"ec30771a"}[chunkId] + ".chunk.js";
};